/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs */

const en_admin_resources_color_image_input_fallback_color_hint = /** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown in the calendar and timeline to help tell resources apart.`)
};

const de_admin_resources_color_image_input_fallback_color_hint = /** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird im Kalender und in der Timeline angezeigt, damit Ressourcen leicht zu unterscheiden sind.`)
};

const es_admin_resources_color_image_input_fallback_color_hint = /** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se muestra en el calendario y la Timeline para distinguir recursos fácilmente.`)
};

const fr_admin_resources_color_image_input_fallback_color_hint = /** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichée dans le calendrier et la Timeline pour distinguer facilement les ressources.`)
};

/** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */
const it_admin_resources_color_image_input_fallback_color_hint = en_admin_resources_color_image_input_fallback_color_hint;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */
const pt_br2_admin_resources_color_image_input_fallback_color_hint = en_admin_resources_color_image_input_fallback_color_hint;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */
const pl_admin_resources_color_image_input_fallback_color_hint = en_admin_resources_color_image_input_fallback_color_hint;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */
const hu_admin_resources_color_image_input_fallback_color_hint = en_admin_resources_color_image_input_fallback_color_hint;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs) => LocalizedString} */
const ro_admin_resources_color_image_input_fallback_color_hint = en_admin_resources_color_image_input_fallback_color_hint;

/**
* | output |
* | --- |
* | "Shown in the calendar and timeline to help tell resources apart." |
*
* @param {Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_color_image_input_fallback_color_hint = /** @type {((inputs?: Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Color_Image_Input_Fallback_Color_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_color_image_input_fallback_color_hint(inputs)
	if (locale === "de") return de_admin_resources_color_image_input_fallback_color_hint(inputs)
	if (locale === "es") return es_admin_resources_color_image_input_fallback_color_hint(inputs)
	if (locale === "fr") return fr_admin_resources_color_image_input_fallback_color_hint(inputs)
	if (locale === "it") return it_admin_resources_color_image_input_fallback_color_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_color_image_input_fallback_color_hint(inputs)
	if (locale === "pl") return pl_admin_resources_color_image_input_fallback_color_hint(inputs)
	if (locale === "hu") return hu_admin_resources_color_image_input_fallback_color_hint(inputs)
	return ro_admin_resources_color_image_input_fallback_color_hint(inputs)
});
export { admin_resources_color_image_input_fallback_color_hint as "admin.resources.color_image_input.fallback_color_hint" }